module.exports = __webpack_public_path__ + "static/banner-2-525253d76824abcd115fca2f3f5f966d.jpg";